// extracted by mini-css-extract-plugin
module.exports = {"md":"list-input-multiple-popup_md_2_Sq0","ios":"list-input-multiple-popup_ios_GFrMz","page":"list-input-multiple-popup_page_zp6vn","list":"list-input-multiple-popup_list_ySVJC"};